/* Free-shipping progress bar.
   Listens to the cart requests the theme already makes (fetch + jQuery ajax)
   and re-renders from the cart total in their responses. It does not add its own
   cart refresh; the only extra request is a read-only /cart.js after /cart/add,
   when the add response has no cart total in it. */
(function () {
  var cfg = window.freeShippingConfig;
  if (!cfg || window.__fsbLoaded) return;
  window.__fsbLoaded = true;

  var CART_URL = /\/cart(\/(add|change|update|clear))?(\.js)?$/;

  function cleanUrl(url) {
    return String(url || '').split('#')[0].split('?')[0];
  }

  function thresholdCents() {
    var base = cfg.thresholds[cfg.country];
    if (!base) return null;
    var rate = 1;
    if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
      rate = parseFloat(Shopify.currency.rate) || 1;
    }
    return Math.round(base * rate);
  }

  function fmt(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function render(total) {
    if (typeof total !== 'number') return;
    cfg.total = total;
    var t = thresholdCents();
    var els = document.querySelectorAll('[data-free-shipping]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!t || total <= 0) {
        el.hidden = true;
        continue;
      }
      var unlocked = total >= t;
      var pct = Math.min(total / t, 1) * 100;
      el.hidden = false;
      el.classList.toggle('is-unlocked', unlocked);
      el.querySelector('.fsb__fill').style.width = pct + '%';
      el.querySelector('.fsb__track').setAttribute('aria-valuenow', String(Math.round(pct)));
      el.querySelector('.fsb__msg').textContent = unlocked
        ? 'Free shipping unlocked ✓'
        : 'You’re ' + fmt(t - total) + ' away from free shipping!';
    }
  }

  function handle(data) {
    if (data && typeof data.total_price === 'number') render(data.total_price);
  }

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // 1. fetch-based cart updates (cart page quantity/remove, product form add)
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = cleanUrl(typeof input === 'string' ? input : input && input.url);
      var p = origFetch.apply(this, arguments);
      if (CART_URL.test(url)) {
        p.then(function (res) {
          res.clone().json().then(function (d) {
            if (d && typeof d.total_price === 'number') {
              handle(d);
            } else if (/\/cart\/add/.test(url)) {
              origFetch(root + 'cart.js', { credentials: 'same-origin' })
                .then(function (r) { return r.json(); })
                .then(handle)
                .catch(function () {});
            }
          }).catch(function () {});
        }).catch(function () {});
      }
      return p;
    };
  }

  // 2. jQuery-based cart updates (cart pop-up quantity/remove + post-add refresh)
  function hookJquery() {
    if (!window.jQuery) return;
    jQuery(document).ajaxComplete(function (e, xhr, settings) {
      if (!settings || !CART_URL.test(cleanUrl(settings.url))) return;
      var d = xhr.responseJSON;
      if (!d) {
        try { d = JSON.parse(xhr.responseText); } catch (err) { d = null; }
      }
      handle(d);
    });
  }

  function init() {
    render(cfg.total);
    hookJquery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
